<template>
    <custom-color-picker class="custom-color-picker" :palette="palette" :value="normalizedValue" @input="change"/>
</template>

<style lang="scss">
    .custom-color-picker {
        /*.vc-compact {
            padding: 10px 12px 4px !important;
            width: 100% !important;
            min-height: 38px !important;
            border-radius: 0 !important;
            box-shadow: none !important;
            border: 1px solid #e5ebec !important;
        }*/

        &.vc-swatches {
            width: 100% !important;
            min-height: 40px !important;
            height: auto !important;
            overflow-y: hidden !important;
            box-shadow: none !important;
            border: 1px solid config('colors.grey-light') !important;

            .vc-swatches-box {
                padding: 6px !important;

                .vc-swatches-color-group {
                    width: 24px !important;
                    padding-bottom: 0 !important;
                    margin-right: 6px !important;

                    .vc-swatches-color-it {
                        width: 24px !important;
                    }

                    .vc-swatches-pick {
                        margin-left: 0 !important;
                    }
                }
            }
        }
    }
</style>

<script>
import isEmpty from 'lodash/isEmpty'
import { Swatches } from 'vue-color'

export default {
  components: {
    CustomColorPicker: Swatches
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      palette: [['#c0392b'], ['#e74c3c'], ['#9b59b6'], ['#8e44ad'], ['#2980b9'], ['#3498db'], ['#1abc9c'], ['#16a085'], ['#27ae60'], ['#2ecc71'], ['#f1c40f'], ['#f39c12'], ['#e67e22'], ['#d35400'], ['#ecf0f1'], ['#bdc3c7'], ['#95a5a6'], ['#7f8c8d'], ['#34495e'], ['#2c3e50']]
    }
  },
  computed: {
    normalizedValue () {
      if (isEmpty(this.value)) {
        this.$emit('input', '#000000')
      }
      return this.value
    }
  },
  methods: {
    change (data) {
      this.$emit('input', data.hex)
    }
  }
}
</script>
